/* TINOR product page: gallery, variant-driven UI updates, quantity, sticky bar.
   The variant picker itself lives in theme.js ([data-product-form-wrap] contract);
   this file listens for its `variant:change` event. */
(() => {
  const money = (c) => (window.TINOR ? window.TINOR.money(c) : (c / 100).toFixed(2));
  const strings = (window.theme && window.theme.strings) || {};

  function initGallery(root) {
    const gallery = root.querySelector('[data-gallery]');
    if (!gallery) return null;
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = Array.from(track.children);
    const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
    let current = 0;

    const go = (i, smooth = true) => {
      const n = slides.length;
      if (!n) return;
      i = (i + n) % n;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(i);
    };
    const setActive = (i) => {
      if (i === current) return;
      current = i;
      gallery.classList.toggle('is-not-first', i !== 0);
      thumbs.forEach((t, j) => {
        t.classList.toggle('is-active', j === i);
        if (j === i) {
          t.setAttribute('aria-current', 'true');
          const box = t.parentElement;
          if (box.scrollWidth > box.clientWidth) box.scrollTo({ left: t.offsetLeft - box.offsetLeft - 20, behavior: 'smooth' });
        } else t.removeAttribute('aria-current');
      });
      // Pause any playing media that left the viewport.
      slides.forEach((s, j) => {
        if (j === i) return;
        s.querySelectorAll('video').forEach(v => v.pause());
        s.querySelectorAll('iframe').forEach(f => {
          try {
            f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }), '*');
            f.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
          } catch (_) {}
        });
      });
    };
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const w = track.clientWidth || 1;
        setActive(Math.round(track.scrollLeft / w));
      });
    }, { passive: true });

    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => go(current - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => go(current + 1));
    thumbs.forEach(t => t.addEventListener('click', () => go(Number(t.dataset.thumb))));
    track.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });

    // 3D models: swap the poster for <model-viewer> on demand.
    gallery.addEventListener('click', e => {
      const btn = e.target.closest('[data-load-model]');
      if (!btn) return;
      const frame = btn.closest('.pdp-gallery__frame');
      const tpl = frame.querySelector('template[data-model-template]');
      if (!tpl) return;
      frame.innerHTML = '';
      frame.appendChild(tpl.content.cloneNode(true));
      frame.classList.add('is-model');
      if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: (err) => {
          if (err) return;
          const mv = frame.querySelector('model-viewer');
          if (mv && window.Shopify.ModelViewerUI) new Shopify.ModelViewerUI(mv);
        } }]);
      }
    });

    return {
      showMedia(id) {
        const i = slides.findIndex(s => s.dataset.mediaId === String(id));
        if (i >= 0) go(i);
      }
    };
  }

  function initProduct(root) {
    if (!root || root.dataset.pdpInit) return;
    root.dataset.pdpInit = '1';
    const gallery = initGallery(root);
    const $ = (s) => root.querySelector(s);
    const $$ = (s) => Array.from(root.querySelectorAll(s));

    // Quantity stepper (input is tied to the product form via form="").
    $$('[data-qty-step]').forEach(btn => btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input');
      const v = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + Number(btn.dataset.qtyStep)));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));

    // Rating → reviews section.
    $$('[data-scroll-reviews]').forEach(a => a.addEventListener('click', e => {
      const target = document.getElementById('reviews') || document.querySelector('[id$="__reviews"], [id*="__reviews_"], [data-reviews]');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));

    root.addEventListener('variant:change', e => {
      const v = e.detail;
      if (!v) return;
      const sale = v.compare_at_price > v.price;

      // Price block
      const now = $('[data-price-now]'); now && (now.textContent = money(v.price));
      const was = $('[data-price-was]');
      if (was) { was.textContent = sale ? money(v.compare_at_price) : ''; was.hidden = !sale; }
      const saveEl = $('[data-price-save]');
      const priceBox = $('[data-pdp-price]');
      if (saveEl && priceBox) {
        saveEl.hidden = !sale;
        if (sale) saveEl.textContent = priceBox.dataset.saveTemplate.replace('[amount]', money(v.compare_at_price - v.price));
      }
      const inst = $('[data-installment-amount]');
      if (inst && priceBox) inst.textContent = money(Math.floor(v.price / Number(priceBox.dataset.installments || 3)));

      // Gallery badges
      const pct = $('[data-sale-pct]');
      if (pct) { pct.hidden = !sale; if (sale) pct.textContent = '−' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'; }
      const so = $('[data-soldout-badge]'); so && (so.hidden = v.available);

      // Sticky bar
      const sp = $('[data-sticky-price]'); sp && (sp.textContent = money(v.price));
      const spm = $('[data-sticky-price-mobile]'); spm && (spm.textContent = money(v.price));
      const sw = $('[data-sticky-was]'); if (sw) { sw.hidden = !sale; sw.textContent = sale ? money(v.compare_at_price) : ''; }
      const sv = $('[data-sticky-variant]'); sv && (sv.textContent = ' · ' + v.title);
      const sb = $('[data-sticky-button]'); sb && (sb.disabled = !v.available);
      const sl = $('[data-sticky-label]'); sl && (sl.textContent = v.available ? strings.addToCart + ' · ' + money(v.price) : strings.soldOut);
      const sls = $('[data-sticky-label-short]'); sls && (sls.textContent = v.available ? strings.addToCart : strings.soldOut);
      const si = $('[data-sticky-img]');
      if (si && v.featured_media && v.featured_media.preview_image) {
        si.removeAttribute('srcset');
        si.src = v.featured_media.preview_image.src + (v.featured_media.preview_image.src.includes('?') ? '&' : '?') + 'width=120';
      }

      // Media + URL
      if (gallery && v.featured_media) gallery.showMedia(v.featured_media.id);
      if (root.dataset.url && window.history.replaceState) {
        window.history.replaceState({}, '', root.dataset.url + '?variant=' + v.id);
      }
    });

    // Add-to-cart total: product price × quantity + every ticked upsell.
    const addBtn = $('[data-add-button]');
    if (addBtn) {
      let unit = Number(addBtn.dataset.unitPrice || 0);
      let available = !addBtn.disabled;
      const qtyInput = () => root.querySelector('input[name="quantity"]');
      const updateTotal = () => {
        if (!available) return;
        const qty = Math.max(1, parseInt(qtyInput() ? qtyInput().value : 1, 10) || 1);
        const extras = $$('.pdp-upsell__input').filter(i => i.checked).reduce((sum, i) => sum + Number(i.dataset.upsellPrice || 0), 0);
        const text = strings.addToCart + ' · ' + money(unit * qty + extras);
        const label = $('[data-add-label]'); label && (label.textContent = text);
        const sl = $('[data-sticky-label]'); sl && (sl.textContent = text);
      };
      root.addEventListener('variant:change', e => {
        if (!e.detail) return;
        unit = e.detail.price;
        available = e.detail.available;
        updateTotal();
      });
      root.addEventListener('change', e => {
        if (e.target.matches('.pdp-upsell__input, input[name="quantity"]')) updateTotal();
      });
      root.addEventListener('input', e => {
        if (e.target.matches('input[name="quantity"]')) updateTotal();
      });
      updateTotal();
    }
  }

  const boot = (scope = document) => scope.querySelectorAll('[data-pdp]').forEach(initProduct);
  boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
